import script from "./PipGame.vue?vue&type=script&setup=true&lang=js"
export * from "./PipGame.vue?vue&type=script&setup=true&lang=js"

import "./PipGame.vue?vue&type=style&index=0&id=21724baa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21724baa"]])

export default __exports__